<template>
  <div class="we-try-hard__container">
    <div class="we-try-hard__body container">
      <div class="we-try-hard__content">
        <h2 class="we-try-hard__header">
          With SkyCoach you get
        </h2>
        <div class="points__container">
          <div class="points__item">
            <div class="points__item-logo">
              <img
                src="/images/key_features/pro_players.svg"
                alt=""
                class="points__item-logo-img"
                height="16"
                width="16">
            </div>
            <div class="points__item-text">
              Support from PRO players
            </div>
          </div>
          <div class="points__item">
            <div class="points__item-logo">
              <img
                src="/images/key_features/own_team.svg"
                alt=""
                class="points__item-logo-img"
                height="16"
                width="16">
            </div>
            <div class="points__item-text">
              In-house boosting teams
            </div>
          </div>
          <div class="points__item">
            <div class="points__item-logo">
              <img
                src="/images/key_features/vpn.svg"
                alt=""
                class="points__item-logo-img"
                height="16"
                width="16">
            </div>
            <div class="points__item-text">
              VPN <br> Protection
            </div>
          </div>
          <div class="points__item">
            <div class="points__item-logo">
              <img
                src="/images/key_features/money_back.svg"
                alt=""
                class="points__item-logo-img"
                height="16"
                width="16">
            </div>
            <div class="points__item-text">
              Money-back guarantee
            </div>
          </div>
          <div class="points__item">
            <div class="points__item-logo">
              <img
                src="/images/key_features/fast.svg"
                alt=""
                class="points__item-logo-img"
                height="16"
                width="16">
            </div>
            <div class="points__item-text">
              Instant order processing
            </div>
          </div>
          <div class="points__item">
            <div class="points__item-logo">
              <img
                src="/images/logos/skycoach_symbol_white.svg"
                alt=""
                class="points__item-logo-img"
                height="16"
                width="12">
            </div>
            <div class="points__item-text">
              Team trying hard to elevate your play!
            </div>
          </div>
        </div>

        <div class="list-of-qualities__container">
          <div class="list-of-qualities__item">
            <div class="shape-check" />
            <span>Connect with our friendly managers and PRO players</span>
          </div>
          <div class="list-of-qualities__item">
            <div class="shape-check" />
            <span>Benefit from 24/7 support for all your gaming needs</span>
          </div>
          <div class="list-of-qualities__item">
            <div class="shape-check" />
            <span>Trust in our secure service—your data’s safety is our top priority</span>
          </div>
          <div class="list-of-qualities__item">
            <div class="shape-check" />
            <span>Enjoy peace of mind with our instant money-back guarantee</span>
          </div>
          <div class="list-of-qualities__item">
            <div class="shape-check" />
            <span>Play with one of the best PROs out there</span>
          </div>
          <div class="list-of-qualities__item">
            <div class="shape-check" />
            <span>Take your gaming experience to new heights!</span>
          </div>
        </div>
      </div>
    </div>
    <div class="we-try-hard__gradient--top" />
    <div class="we-try-hard__gradient--bottom" />
  </div>
</template>

<script>
export default {
  name: 'WeTryHard',
};
</script>

<style lang="scss" scoped>
  .we-try-hard__container {
    position: relative;
    background-image: url(/images/bg/we-try-hard-bg__1920.jpg);
    background-repeat: no-repeat;
    background-size: auto 80%;
    background-position: center 0;
  }

  .we-try-hard__header {
    position: relative;
    font-size: 21px;
    font-weight: 500;
    margin-bottom: 25px;
    z-index: 2;
  }

  .we-try-hard__content {
    position: relative;
    z-index: 2;
  }

  .points__container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 18px 24px;
    margin-bottom: 30px;
  }

  .points__item {
    display: flex;
  }

  .points__item-logo {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: $color--basic-blue;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 12px;

    .points__item-logo-img {
      width: auto;
      height: 50%;
    }
  }

  .points__item-text {
    font-size: 13px;
    font-weight: 500;
  }

  .list-of-qualities__container {
    font-size: 13px;
    font-weight: 400;
  }

  .list-of-qualities__item {
    margin-bottom: 14px;
    display: flex;
    align-items: center;
  }

  .shape-check {
    --shape-color: #{$color--basic-green};

    display: block;
    flex-shrink: 0;
    width: 12px;
    height: 10px;
    margin-right: 14px;
  }

  .we-try-hard__gradient--bottom,
  .we-try-hard__gradient--top {
    position: absolute;
    left: 0;
    width: 100%;
    height: 10%;
    z-index: 1;
  }

  .we-try-hard__gradient--top {
    top: 0;
    background: linear-gradient(180deg, $color--basic-black 0%, rgba($color--basic-black, 0) 100%);
  }

  .we-try-hard__gradient--bottom {
    bottom: 0;
    background: linear-gradient(0deg, $color--basic-black 0%, rgba($color--basic-black, 0) 100%);
  }

  @media only screen and #{$screen-more-or-1024} {
    .we-try-hard__container {
      background-size: 120%;
      background-position: center 20%;
    }

    .we-try-hard__header {
      font-size: 25px;
      margin-bottom: 31px;
    }

    .we-try-hard__content {
      display: grid;
      grid-template-columns: auto auto;
    }

    .points__container {
      grid-column: 1;
      grid-auto-rows: 48px;
      grid-gap: 24px;
    }

    .points__item {
      align-items: center;
    }

    .points__item-logo {
      width: 48px;
      height: 48px;
    }

    .points__item-text {
      width: 50%;
    }

    .list-of-qualities__container {
      margin-top: -45px;
    }

    .shape-check {
      margin-right: 16px;
    }
  }

  @media only screen and (min-width: 1200px) {
    .points__container {
      grid-template-columns: repeat(3, 1fr);
    }
  }
</style>
